import { render, staticRenderFns } from "./BasePageContent.vue?vue&type=template&id=00836557&"
import script from "./BasePageContent.vue?vue&type=script&lang=js&"
export * from "./BasePageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports